import React, { useState } from "react";
import { Button } from "react-materialize";
import $ from "jquery";
import API from "../../utils/API";
import Func from "../../utils/Func";
import Handle from "../Container/modal.handle";
import ModalDone from "../Container/modal.done";
import ModalError from "../Container/modal.error";
import ModalWarning from "../Container/modal.warning";

export default function BtnExportSubmit({
  events,
  header,
  filters,
  activeTab = "requests" }) {
  const [resData, setResData] = useState({
    spreadsheetUrl: "",
    status: "",
    err: 0,
    err_msg: "" });

  const callbackEvent = {
    OnClose: function () {
      setResData({ spreadsheetUrl: "", status: "", err: 0, err_msg: "" });
    },
    OnComplete: function () {
      events.OnComplete();
    } };

  const handleEvents = {
    OnClose: function () {
      $("body").css({ overflow: "auto" });
      setResData({ spreadsheetUrl: "", status: "", err: 0, err_msg: "" });
    },
    OnSubmit: function () {
      // 1) exportType
      let exportType = "all";
      if ($('input[name="export-column-displayed"]').is(":checked")) {
        exportType = "displayed";
      }

      // 2) filters: ใช้จาก props ถ้ามี, ไม่งั้น fallback ไปอ่านจากฟอร์มเดิม
      let effectiveFilters = filters;
      if (!effectiveFilters || typeof effectiveFilters != "object") {
        effectiveFilters = Func.GetDataForm(
          $("#form-filter-request").serializeArray()
        );
      }
      // ✅ บังคับ export 10,000 แถวเสมอ (และให้เริ่มหน้าแรก)
      effectiveFilters = {
        ...effectiveFilters,
        limit: 10000,
        page: 1 };

      // 3) เลือก endpoint ตามแท็บ
      const endpoint =
        activeTab === "summary" ? "team/summary/export" : "team/request/export";

      Handle.loading.OnShow();
      const mainFunc = async () =>
        await API.post(endpoint, {
          params: ({
            userID: window.$user_profile.idu,
            userEmail: window.$user_profile.emailadd,
            exportType: exportType,
            filters: effectiveFilters }) });

      mainFunc()
        .then((res) => {
          Handle.loading.OnHide();
          const decrypt = (res?.data);
          if (decrypt?.status === "success") {
            setResData(decrypt);
          } else {
            setResData({
              spreadsheetUrl: "",
              err: 1,
              err_msg: `Failes : ` + (decrypt?.err_msg ?? "") });
          }
        })
        .catch(() => {
          Handle.loading.OnHide();
          setResData({ spreadsheetUrl: "", err: 1, err_msg: "" });
        });
    } };

  // Rendering states
  if (resData?.err === 1) {
    return (
      <ModalWarning
        header={header}
        content={resData.err_msg}
        callbackEvent={callbackEvent}
      />
    );
  } else if (resData?.err === 2) {
    return (
      <ModalError
        header={header}
        content={resData.err_msg}
        callbackEvent={callbackEvent}
      />
    );
  } else if (resData?.status === "success") {
    const content =
      "<span style=''>Your report has been exported.</span><a href='" +
      resData.spreadsheetUrl +
      "' target='_blank' style='position: unset; display: inline-block;'>Open the sheet.</a>";
    const addon = { setTime: "no", height: "240px" };
    return (
      <ModalDone
        header={header}
        content={content}
        callbackEvent={callbackEvent}
        addon={addon}
      />
    );
  }

  return (
    <Button
      className=""
      id="btn-submit-export"
      node="button"
      onClick={handleEvents.OnSubmit}
    >
      Confirm
    </Button>
  );
}


